module.exports = __webpack_public_path__ + "static/img/1btn2.bafb8d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/1btn2.png
// module id = a+mB
// module chunks = 215